import amplitude from 'amplitude-js';

export const initAmplitude = () => {
    amplitude.getInstance().init('f1aa82b665d1d82b677060b7073c1ab4');
};

export const setAmplitudeUserDevice = installationToken => {
    amplitude.getInstance().setDeviceId(installationToken);
};

export const setAmplitudeUserId = userId => {
    amplitude.getInstance().setUserId(userId);
};

export const setAmplitudeUserProperties = properties => {
    amplitude.getInstance().setUserProperties(properties);
};

export const sendAmplitudeData = (eventType, eventProperties) => {
    amplitude.getInstance().logEvent(eventType, eventProperties);
};